module.exports = __webpack_public_path__ + "assets/Unrest.37b2910b.svg";